import { Nullable } from '@app/types';
import { Instance, LocaleType, ProfileWebHookFields, WebhookEvents } from '@const/consts';
import { ICurrentWebHook, IWebHook } from '@store/modules/boxes/types';
import { ProfileWebHooksValues } from '@views/profile/types';
import { ProfileWebHooksEventsSettings } from '@views/profile/consts';

export const normalizeProfileLocale = (
  locale: string | null | undefined,
  instance: Instance | string
): LocaleType => {
  const normalizedLocale = locale?.replace('_', '-') as LocaleType | undefined
  const isSupportedLocale = normalizedLocale !== undefined &&
    Object.values(LocaleType).includes(normalizedLocale)
  const isRussianLocaleAllowed = normalizedLocale !== LocaleType.RU ||
    instance === Instance.RU

  return isSupportedLocale && isRussianLocaleAllowed
    ? normalizedLocale
    : LocaleType.EN
}

export const getBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() || '');
    reader.onerror = error => reject(error);
  });
}

export const checkWebhookEvents = (webhookEvents: Nullable<Array<Nullable<WebhookEvents>>>): (value: WebhookEvents) => boolean => {
  return (value: WebhookEvents) =>
    webhookEvents ? webhookEvents.includes(value) : false
}

export const getWebHookInitialValues = (webHook: ICurrentWebHook): ProfileWebHooksValues => {
  const {
    isWebhookEnabled,
    webhookUrl,
    webhookAuthType,
    webhookAuthToken,
    webhookEvents
  } = webHook

  const event = checkWebhookEvents(webhookEvents)

  return {
    [ProfileWebHookFields.IS_WEBHOOK_ENABLE]: isWebhookEnabled,
    [ProfileWebHookFields.WEBHOOK_URL]: webhookUrl,
    [ProfileWebHookFields.WEBHOOK_AUTH_TYPE]: webhookAuthType,
    [ProfileWebHookFields.WEBHOOK_AUTH_TOKEN]: webhookAuthToken,
    [WebhookEvents.SENT]: event(WebhookEvents.SENT),
    [WebhookEvents.RECEIVED]: event(WebhookEvents.RECEIVED),
    [WebhookEvents.SIGNED]: event(WebhookEvents.SIGNED),
    [WebhookEvents.DECLINED]: event(WebhookEvents.DECLINED),
    [WebhookEvents.APPROVED]: event(WebhookEvents.APPROVED),
    [WebhookEvents.ACQUAINTED]: event(WebhookEvents.ACQUAINTED),
    [WebhookEvents.STOPPED_PROCESS]: event(WebhookEvents.STOPPED_PROCESS)
  }
}

export const getValuesToUpdate = (values: ProfileWebHooksValues): IWebHook => {
  const {
    isWebhookEnabled,
    webhookUrl,
    webhookAuthType,
    webhookAuthToken
  } = values

  const webhookEvents: WebhookEvents[] = []

  ProfileWebHooksEventsSettings.map(({ fieldName }) =>
    (values[fieldName] && WebhookEvents[fieldName]) &&
      webhookEvents.push(WebhookEvents[fieldName]))

  return {
    isWebhookEnabled,
    webhookUrl,
    webhookAuthType,
    webhookAuthToken,
    webhookEvents
  }
}
